import React, { useEffect, useRef, useState } from 'react';
import ApexCharts from 'apexcharts';
import setting from '../../config.json';
import TauriSectionModalVisual from '../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';

const TauriPieVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
  const chartRef = useRef(null);
  const [selectedVisual, setSelectedVisual] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!chartData || !chartData?.[0]) return;

    const handleDataPointSelection = (event, chartContext, config) => {
      const selectedSliceIndex = config.dataPointIndex;
      const title = chartConfig.binding.context.point.onClick.selectedValueColumn;
      const modalTitle = chartConfig.binding.context.point.onClick.selectedTitle;
      const selectedDesc = chartData[selectedSliceIndex][chartConfig.binding.data.title];
      const selectedVal = chartData[selectedSliceIndex][title];
      const selectedTitle = chartConfig.title;

      if (chartConfig.binding.context.point.onClick.visual || Array.isArray(chartConfig.binding.context.point.onClick.visuals)) {
        let selectedVisual = null;
        if (chartConfig.binding.context.point.onClick.visuals) {
          selectedVisual = chartConfig.binding.context.point.onClick.visuals;
        } else {
          // Handle single visual
          selectedVisual = chartConfig.binding.context.point.onClick.visual;
        }

        setSelectedVisual(selectedVisual);
        setSelectedData({ title, selectedDesc, selectedVal, selectedTitle, modalTitle });

        const tauriElement = document.querySelector('.tauri-host-container');
        if (tauriElement) {
          if (event) {
            const { left, top, right, bottom } = tauriElement.getBoundingClientRect();
            let posX = event.clientX;
            let posY = event.clientY;
            if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
              posX = event.clientX - setting.modalMinWidth;
            }
            if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
              posY = event.clientY - setting.modalMinHeight;
            }

            setModalPosition({ x: posX, y: posY });
          }
        }
      }
    };

    const options = {
      chart: {
        type: chartConfig.type,
        ...chartOptions.chart,
        toolbar: {
          show: true,
          tools: {
            download: true,
          }
        },
        events: {
          dataPointSelection: handleDataPointSelection,
        },
      },
      colors: chartData.map((_, index) => {
        const paletteIndex = chartData.length === 1 ? 0 : index;
        const palette = chartPalettes[paletteIndex % chartPalettes.length];
        return palette.ranges;
      }).flat(),
      series: chartData.map(data => parseFloat(data[chartConfig.binding.data.value])), // Convert values to numbers
      labels: chartData?.map(data => data[chartConfig?.binding?.data?.title] || ''),
      tooltip: {
        y: {
          formatter: (value, { seriesIndex, dataPointIndex, w }) => {
            const tooltipValue = chartData[dataPointIndex][chartConfig?.binding?.data?.tooltip] || '';
            const formattedValue = tooltipValue.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
            if (chartConfig.binding.data.currency) {
              return formattedValue + ' (PHP)';
            } else {
              return formattedValue;
            }

          },
          style: chartOptions.tooltip.style,
        }
      },
      // fill: {
      //   type: 'gradient',
      //   gradient: {
      //     shade: 'dark',
      //     type: 'diagonal1', // Diagonal gradient
      //     shadeIntensity: 0.6,
      //     gradientToColors: ['#FFA751', '#1D976C', '#2B32B2'], // Gradient end colors
      //     opacityFrom: 1,
      //     opacityTo: 1,
      //     stops: [0, 100],
      //   },
      // },
      legend: chartOptions.legend,
      dataLabels: {
        ...chartOptions.dataLabels,
        formatter: (value) => {
          const formattedValue = value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
          return chartConfig.binding.data.percent ? `${formattedValue}%` : formattedValue;
        }
      },
      plotOptions: chartOptions.plotOptions,
      animations: chartOptions.animations
    };

    const chart = new ApexCharts(chartRef.current, options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [chartData, chartConfig]);

  return (
    <div>
      <div className="chart-content">
        <div ref={chartRef}></div>
      </div>
      {selectedVisual && (
        chartConfig.binding.context.point.onClick.visuals ? (
          <TauriSectionModalMultiVisual
            show={selectedVisual !== null}
            onHide={() => setSelectedVisual(null)}
            selectedData={selectedData}
            visual={selectedVisual}
            columnSize={columnSize}
            rowSize={rowSize}
            style={{ top: modalPosition.y, left: modalPosition.x }}
            palettes={palettes}
            themes={themes}
          />
        ) : (
          <TauriSectionModalVisual
            show={selectedVisual !== null}
            onHide={() => setSelectedVisual(null)}
            selectedData={selectedData}
            visual={selectedVisual}
            columnSize={columnSize}
            rowSize={rowSize}
            style={{ top: modalPosition.y, left: modalPosition.x }}
            palettes={palettes}
            themes={themes}
          />
        )
      )}
    </div>
  );
};

export default TauriPieVisual;
